module.exports = __webpack_public_path__ + "static/media/DSC_0022.00c537f0.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/people/DSC_0022.jpg
// module id = 616
// module chunks = 0